'use strict';

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.directive("ifOperation", function ($animate, budgetService) {
  return {
    transclude: 'element',
    priority: 1000,
    terminal: true,
    restrict: 'AC',
    $$tlb: true,
    link: function link($scope, $element, $attrs, ctrl, $transclude) {
      if (budgetService.isNommageOperation()) {
        $transclude($scope, function (clone) {
          $animate.enter(clone, $element.parent(), $element);
        });
      }
    }
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/budget/if-operation.js
// module id = 2684
// module chunks = 13